var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 2.1665C3.88323 2.1665 2.16699 3.88275 2.16699 5.99984V10.7378C2.16699 11.0139 2.39085 11.2378 2.66699 11.2378C2.94313 11.2378 3.16699 11.0139 3.16699 10.7378V5.99984C3.16699 4.43503 4.43552 3.1665 6.00033 3.1665H10.6756C10.9517 3.1665 11.1756 2.94265 11.1756 2.6665C11.1756 2.39036 10.9517 2.1665 10.6756 2.1665H6.00033Z",
    fill: "#0E46C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2687 4.52868C10.1081 4.28719 7.89261 4.28719 5.73198 4.52868C5.11646 4.59747 4.62184 5.08187 4.54929 5.70216C4.29303 7.89314 4.29303 10.1065 4.54929 12.2975C4.62184 12.9178 5.11646 13.4022 5.73198 13.471C7.89261 13.7125 10.1081 13.7125 12.2687 13.471C12.8842 13.4022 13.3788 12.9178 13.4514 12.2975C13.7076 10.1065 13.7076 7.89314 13.4514 5.70216C13.3788 5.08187 12.8842 4.59747 12.2687 4.52868ZM5.84305 5.52249C7.92987 5.28926 10.0708 5.28926 12.1576 5.52249C12.3159 5.54017 12.4403 5.66531 12.4582 5.81832C12.7054 7.93213 12.7054 10.0675 12.4582 12.1813C12.4403 12.3344 12.3159 12.4595 12.1576 12.4772C10.0708 12.7104 7.92987 12.7104 5.84305 12.4772C5.68482 12.4595 5.56041 12.3344 5.54252 12.1813C5.29529 10.0675 5.29529 7.93213 5.54252 5.81832C5.56041 5.66531 5.68482 5.54017 5.84305 5.52249Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8c19837e80ea0cdd9e292fba6c0a58d7.svg";
export { ForwardRef as ReactComponent };